import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-document-type-reference-options',
  templateUrl: './document-type-reference-options.component.html',
  styleUrls: ['./document-type-reference-options.component.css']
})
export class DocumentTypeReferenceOptionsComponent implements OnInit {
  dialog:any;
  form: FormGroup;
  constructor(
    private dialogRef: MatDialogRef<DocumentTypeReferenceOptionsComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) { 
    this.dialog = data;
  }

  ngOnInit() {
    this.form = new FormGroup({
      allowManual:new FormControl(this.dialog.allowManual)
    });
  }
  onConfirm() {
    this.dialogRef.close(this.form.value);
  }
  onCancel() {
    this.dialogRef.close();
  }
}
